<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-11-16 12:40:48
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-12-03 17:52:31
 * @FilePath: \vue-privilege-routing\src\pages\system\system-actor\index.vue
-->
<template>
  <div class="app-container">
    <el-row>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="page.param.title" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="类别">
          <el-select
            v-model="page.param.categoryId"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in categoryIdOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="page.param.goodsState"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search" class="el-icon-search">
            查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-col style="text-align: left;margin-bottom: 5px;">
        <el-button @click="add()" type="primary" class="el-icon-edit-outline">
          添加</el-button
        >
      </el-col>
    </el-row>

    <el-table
      v-loading="page.loading"
      :data="page.data"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @sort-change="sortChange"
    >
    <el-table-column label="id" prop="title" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.organizeId }}
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="title" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.organizeShorthand }}
        </template>
      </el-table-column>
      <el-table-column label="类别" prop="categoryId" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.dictType.dictLabel }}
        </template>
      </el-table-column>
      <el-table-column label="门店" prop="storeId" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.storeTitle }}
        </template>
      </el-table-column>
      <el-table-column label="封面" prop="organizeLogo" sortable="custom">
        <template slot-scope="scope">
          <img
            :src="scope.row.organizeLogo"
            v-if="'' != scope.row.organizeLogo"
            width="auto"
            height="30px"
          />
        </template>
      </el-table-column>
      <el-table-column label="销量" prop="sales" sortable="custom" width="80px">
        <template slot-scope="scope">
          {{ scope.row.sales }}
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        sortable="custom"
        width="80px"
      >
        <template slot-scope="scope">
          {{ scope.row.dictStatus.dictLabel }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.updateTime }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row.organizeId)">编辑</el-button>
          <!--          <el-button size="mini" type="danger" @click="del(scope.row.id)"><i class="icon-delete"></i>删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="page.total > 0"
      class="goods-pagination"
      :total="page.total"
      :page.sync="page.param.currentPage"
      :limit.sync="page.param.pageSize"
      @pagination="fetchData"
    />
    <!-- Form -->
    <el-dialog
      :visible.sync="visible"
      title="主体申请"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="app-container">
        <el-form
          :model="actorForm"
          status-icon
          ref="ruleForm"
          label-position="right"
          size="small"
          label-width="150px"
          slot="dialog"
          :rules="rules"
        >
          <el-form-item prop="title" label="名称：">
            <el-input
              v-model="actorForm.organizeName"
              style="width:400px"
              placeholder="名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="title" label="简称：">
            <el-input
              v-model="actorForm.organizeShorthand"
              style="width:400px"
              placeholder="简称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="categoryId" label="类别：">
            <el-select
              v-model="actorForm.organizeType"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="organizeLogo" label="图片：">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :file-list="showImageList"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="imageAfterUpload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="postage" label="电话：">
            <el-input
              v-model="actorForm.organizeTel"
              style="width:400px"
              placeholder="电话："
            ></el-input>
          </el-form-item>
          <el-form-item label="选择位置">
            <el-button type="primary" @click="showMap">选择位置</el-button>
            <silk-map :dialogVisible="showMapVisible"></silk-map>
          </el-form-item>

          <el-form-item prop='latitude' label="纬度：">
            <el-input v-model="actorForm.latitude" style="width:400px" placeholder="纬度"></el-input>
          </el-form-item>

          <el-form-item prop='longitude' label="经度：">
            <el-input v-model="actorForm.longitude" style="width:400px" placeholder="经度"></el-input>
          </el-form-item>
          <el-form-item prop="status" label="状态：">
            <el-select
              v-model="actorForm.organizeStatus"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="processLog" label="流程日志：">
            <el-input
              type="textarea"
              v-model="actorForm.processLog"
              style="width:400px"
              placeholder="流程日志"
            ></el-input>
          </el-form-item>

          <el-button @click="submit()">提交</el-button>
        </el-form>
      </div>
    </el-dialog>
    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->
  </div>
</template>

<script>
import { selectUnitList, selectDictByGroup, insertUnit } from '../../../api'
import Pagination from '@/components/Pagination'
import SilkMap from "../../../components/silkworm/amap"

export default {
  components: { Pagination , SilkMap},
  data() {
    this.rules = {
      // groupName: { type: 'string', required: true, trigger: 'blur', message: '分组必填!' },
      // name: { type: 'string', required: true, trigger: 'blur', message: '编码必填!' },
      // value: { type: 'string', required: true, trigger: 'blur', message: '值必填!' }
    }
    return {
      page: {
        loading: true,
        data: null,
        total: 0,
        param: {
          currentPage: 1,
          pageSize: 10,
          sort: 'id desc'
        }
      },
      uploadUrl: '/auths/file/upload',
      visible: false,
      actorForm: {},

      showMapVisible: false, 

      categoryIdOptions: [],

      statusOptions: [],
      imageList: [],
      showImageList: [],
      dialogImageUrl: ''
    }
  },
  created() {
    if (this.$route.query.pageIndex !== undefined) {
      this.page.param.currentPage = this.$route.query.pageIndex
    }
    if (this.$route.query.word !== undefined) {
      this.page.param.title = this.$route.query.word
    }
    this.fetchData()
    this.categoryQuery()
    this.statusQuery()
  },
  provide() {
    console.log("执行到这里了")
    return {
      fatherSetPosition: this.setPosition,
    };
  },
  methods: {
    search() {
      this.page.param.currentPage = 1
      this.fetchData()
    },
    async fetchData() {
      this.page.loading = true
      // 网络请求
      let result = await selectUnitList(this.page.param)
      this.page.data = result.datas
      this.page.total = result.total
      this.page.loading = false
      
    },
    sortChange(data) {
      this.page.param.currentPage = 1
      // this.page.param.sort = getSort(data)
      this.fetchData()
    },
    add() {
      this.actorForm = {}
      this.showImageList = []
      this.imageList = []
      this.visible = true
    },
    // del(val) {
    //   let that = this
    //   this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     postForm('/api/v1/app_store_product/delete', { id: val }).then(res => {
    //       if (res.code == 200) {
    //         that.fetchData()
    //       }
    //     })
    //   })
    // },
    edit(id) {
      const that = this
      that.visible = true
      that.showImageList = []
      that.imageList = []
      that.actorForm = {}
      const unitParam = {
        organizeId: id
      }
      selectUnitList(unitParam).then(res => {
        console.log("这是点击编辑返回来的idunit",res.datas[0])
        that.actorForm = res.datas[0]

        if(undefined != that.actorForm.organizeLogo){
            let iList = that.actorForm.organizeLogo.split(';')
            for(let i = 0;i< iList.length;i++){
              if(null != iList[i] && '' != iList[i]){
                console.log("iList[i]",iList[i])
                that.showImageList.push({name: i, url: '/auths' + iList[i]})
                that.imageList.push(iList[i])
              }
            }
          }
          that.visible = true
      })
      
    },
    submit() {
      let that = this
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.actorForm.organizeLogo = ''
          that.imageList.forEach(function(x) {
            that.actorForm.organizeLogo = that.actorForm.organizeLogo + x + ';'
          })
          insertUnit(this.actorForm).then(res =>{
            console.log("保存res",res)
              console.log("保存成功")
              that.fetchData()
              that.visible = false
          })
          
        }
      })
    },
    categoryQuery() {
      const data = {"groupLabel": "ACTOR_CATEGORY"}
      selectDictByGroup(data).then(res => {
        console.log("在这res",res)
        this.categoryIdOptions = res
      })
    },

    statusQuery() {
      const data = {"groupLabel": "ACTOR_STATUS"}
      selectDictByGroup(data).then(res => {
        console.log("在这res",res)
        this.statusOptions = res
      })
    },
//     detailAfterUpload(res, file) {
//       if (res.code == 200) {
//         this.Form.detail = process.env.VUE_APP_BASE_API + '/file/' + res.data
//       } else {
//         this.$message.error('文件上传失败!')
//       }
//     },
//     statusQuery() {
//       postJson('/api/adm/sys/dict/select', {
//         groupName: 'app_store_product_status'
//       }).then(response => {
//         if (response.code === 200) {
//           this.statusOptions = response.data
//         }
//       })
//     },
    handleRemove(file, fileList) {
      for (let i = 0; i < this.imageList.length; i++) {
        if (
          undefined != file.response &&
          '/file/' + file.response.data == this.imageList[i]
        ) {
          this.imageList.splice(i, 1)
        } else if (
          file.url ==
          process.env.VUE_APP_BASE_API + this.imageList[i]
        ) {
          this.imageList.splice(i, 1)
        }
      }
    },
    handlePictureCardPreview(file) {
      console.log("file",file)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    imageAfterUpload(res, file) {
      if (res.code == 200) {
        this.imageList.push('/auths/file/' + res.data)
      } else {
        this.$message.error('文件上传失败!')
      }
    },

    // 地图开始
    showMap() {
      this.showMapVisible = true
    },
    setPosition(position) {
      console.log("position",position)
      this.actorForm.longitude = position[0]
      this.actorForm.latitude = position[1]
      this.showMapVisible = false
    },
    //地图结束
  }
}
</script>
<style lang="scss" scoped>

.app-container {
  padding: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.goods-pagination {
  text-align: right;
}

::v-deep .el-upload--picture-card {
  width: 150px;
  height: 75px;
  line-height: 75px;
}
::v-deep .el-upload-list--picture-card {
  .el-upload-list__item {
    width: 150px;
    height: 75px;
  }
}
</style>
